// AttendanceConsolidated.js
import React, { useEffect, useState } from "react";
import moment from "moment";
import "./attendanceConsolidated.css";
import Checkbox from "../../components/common/checkbox/checkbox";
import Dropdown from "../../components/common/customDropdown/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";

import * as XLSX from "xlsx"; // Corrected import
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettingComapnay,
  getSettingResignation2,
  getStoreByCompany,
  getStoreByMultipleCompany,
  getStoreDataMonthly,
  getStoreDataMonthlyAll,
} from "../../redux/Action";
import Pagination from "../../Common/Pagination/Pagination";
import { useDebounce } from "../../Common/custom-hooks/UseDbounce";

const AttendanceConsolidated = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedMonthYear, setSelectedMonthYear] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const [currentPage, setCurrentPage] = useState(1);

  const {
    monthlyStoreData,
    allCompanylist,
    monthlyStoreDataPdf,
    allResignationList2,
    getMultipleStores,
  } = useSelector((state) => state.main);

  const [selectedCompanyValue, setSelectedCompanyValue] = useState([]);
  const [selectedStoreValue, setSelectedStoreValue] = useState([]);
  const [showtab, setShowtab] = useState(false);
  const [designationId, setDesignationId] = useState([]);
  const [activeInactive, setActiveInactive] = useState([
    { value: true, label: "Active" },
  ]);
  const [checked, setChecked] = useState(false);
  const [employees, setEmployess] = useState([]);
  const [search, setSearch] = useState("");
  const [showButtons, setShowButtons] = useState(false);
  console.log({ monthlyStoreDataPdf });

  const debouncedSearch = useDebounce(search, 500);

  const currentDate = new Date();
  let currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const months = moment.months();
  const years = [];
  for (let i = currentYear; i >= currentYear - 5; i--) {
    years.push(i);
  }
  const userRole = localStorage.getItem("role");

  useEffect(() => {
    dispatch(getSettingComapnay());
    dispatch(getSettingResignation2());
  }, [dispatch, userRole]);

  useEffect(() => {
    // if (userRole === "management") {
    const id = selectedStoreValue?.map((data) => data?.value);
    const designationIds = designationId?.map((data) => data?.value);
    const activeInactives = activeInactive?.map((data) => data?.value);
    dispatch(
      getStoreDataMonthly(
        id,
        selectedMonthYear,
        debouncedSearch,
        currentPage,
        designationIds,
        activeInactives
      )
    );
    // }
  }, [
    dispatch,
    userRole,
    currentPage,
    selectedStoreValue,
    selectedMonthYear,
    designationId,
    debouncedSearch,
    activeInactive,
  ]);

  useEffect(() => {
    if (monthlyStoreData) {
      setEmployess(monthlyStoreData?.data?.storeUsers);
    }
  }, [dispatch, userRole, currentPage, monthlyStoreData]);

  useEffect(() => {
    if (selectedCompanyValue.length > 0) {
      const data = {
        company_ids: selectedCompanyValue?.map((data) => data?.value),
      };
      dispatch(getStoreByMultipleCompany(data));
    }
  }, [dispatch, userRole, currentPage, selectedCompanyValue]);

  const handleStoreSelector = (selectedValues) => {
    setCurrentPage(1);
    setSelectedStoreValue((prev) => {
      const selectedIds = selectedValues.map((v) => v.value);

      // Keep only values that exist in the new selection
      const updatedValues = prev.filter((v) => selectedIds.includes(v.value));

      // Add new selected values that weren't already in the previous state
      selectedValues.forEach((selected) => {
        if (!updatedValues.some((v) => v.value === selected.value)) {
          updatedValues.push(selected);
        }
      });

      return updatedValues;
    });
  };

  console.log(activeInactive);

  const handleCompanySelector = (selectedValues) => {
    setSelectedCompanyValue((prev) => {
      const selectedIds = selectedValues.map((v) => v.value);

      // Keep only values that exist in the new selection
      const updatedValues = prev.filter((v) => selectedIds.includes(v.value));

      // Add new selected values that weren't already in the previous state
      selectedValues.forEach((selected) => {
        if (!updatedValues.some((v) => v.value === selected.value)) {
          updatedValues.push(selected);
        }
      });

      return updatedValues;
    });
  };

  const handleChange = (value) => {
    console.log(value);

    const [month, year] = value?.value?.split("-");
    setSelectedMonthYear({
      month: months.indexOf(month), // Gets the index of the selected month
      year: parseInt(year), // Converts the year to an integer
    });
    setCurrentPage(1); // Reset to page 1 after month/year change
  };

  const monthYearOptions = [];
  for (let year = currentYear; year >= 2020; year--) {
    for (let monthIndex = currentMonth; monthIndex >= 0; monthIndex--) {
      const monthYear = moment(`${months[monthIndex]} ${year}`, "MMMM YYYY");

      monthYearOptions.push({
        label: monthYear.format("MMM-YY"),
        value: `${months[monthIndex]}-${year}`,
      });
    }
    currentMonth = 11;
  }

  const filteredMonthYearOptions = monthYearOptions.filter((option) => {
    const [month, year] = option.value.split("-");
    return moment(`${month}-${year}`, "MMM-YY").isSameOrBefore(
      currentDate,
      "month"
    );
  });

  const getDaysInMonth = (month, year) => {
    const days = [];
    const daysInMonth = moment(`${year}-${month + 1}`, "YYYY-MM").daysInMonth();
    for (let i = 1; i <= daysInMonth; i++) {
      const dayOfWeek = moment(
        `${year}-${month + 1}-${i}`,
        "YYYY-MM-DD"
      ).format("ddd");
      const fullDate = moment(`${year}-${month + 1}-${i}`, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      days.push({ day: i, dayOfWeek, fullDate });
    }
    return days;
  };

  const days = getDaysInMonth(selectedMonthYear.month, selectedMonthYear.year);

  const allcompanylists = allCompanylist?.data?.map((data) => {
    return {
      label: data.company_name,
      value: data.id,
      disabled: data?.status == true ? false : true,
    };
  });
  const allStorelists = getMultipleStores?.data?.map((data) => {
    return {
      label: data.name,
      value: data._id,
      disabled: data?.status == true ? false : true,
    };
  });
  const designationlist = allResignationList2?.data?.map((data) => {
    return {
      label: data.name,
      value: data._id,
      disabled: data?.status == true ? false : true,
    };
  });

  const handleDesignationChange = (selectedValues) => {
    setCurrentPage(1);

    setDesignationId((prev) => {
      const selectedIds = selectedValues.map((v) => v.value);

      // Keep only values that exist in the new selection
      const updatedValues = prev.filter((v) => selectedIds.includes(v.value));

      // Add new selected values that weren't already in the previous state
      selectedValues.forEach((selected) => {
        if (!updatedValues.some((v) => v.value === selected.value)) {
          updatedValues.push(selected);
        }
      });

      return updatedValues;
    });
  };
  const handleActiveInactive = (selectedValues) => {
    setCurrentPage(1);

    setActiveInactive((prev) => {
      const selectedIds = selectedValues.map((v) => v.value);

      // Keep only values that exist in the new selection
      const updatedValues = prev.filter((v) => selectedIds.includes(v.value));

      // Add new selected values that weren't already in the previous state
      selectedValues.forEach((selected) => {
        if (!updatedValues.some((v) => v.value === selected.value)) {
          updatedValues.push(selected);
        }
      });

      return updatedValues;
    });
  };

  const profileShowHandler = () => {
    setChecked(!checked);
  };

  const searchHandler = (value) => {
    setCurrentPage(1);
    setSearch(value);
  };

  const handleExportExcel = () => {
    const table = document.getElementById("attendance-table");
    const ws = XLSX.utils.table_to_sheet(table);

    // Set column widths dynamically
    const wscols = [
      { wch: 20 }, // Column 1
      { wch: 30 }, // Column 2
      { wch: 25 }, // Column 3
    ];
    ws["!cols"] = wscols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance Data");

    XLSX.writeFile(wb, "attendance.xlsx");
  };

  // const handleExportPDF = () => {
  //   const isChecked = checked;
  //   const doc = new jsPDF("l", "mm", "a4"); // Landscape mode
  //   const table = document.getElementById("attendance-table");

  //   let tableData = [];
  //   let tableHeaders = [];

  //   // Extract table data
  //   const rows = table.querySelectorAll("tr");
  //   rows.forEach((row, rowIndex) => {
  //     let rowData = [];
  //     const cells = row.querySelectorAll("th, td");

  //     cells.forEach((cell, cellIndex) => {
  //       if (rowIndex === 0) {
  //         // Store header row separately
  //         tableHeaders.push(cell.innerText);
  //       } else {
  //         rowData.push(cell);
  //       }
  //     });

  //     // If checked, add a new empty column at index 0 (for images)
  //     if (isChecked) {
  //       rowData.unshift(" "); // Placeholder for images
  //     }

  //     tableData.push(rowData);
  //   });

  //   // If checked, add a new header column for images
  //   if (isChecked) {
  //     tableHeaders.unshift("Profile");
  //   }

  //   const columnStyles = checked
  //     ? { 1: { cellWidth: 30 }, 0: { cellWidth: 18 } }
  //     : { 0: { cellWidth: 30 } };

  //   // Generate PDF Table
  //   doc.autoTable({
  //     head: [tableHeaders],
  //     body: tableData.map((row, rowIndex) =>
  //       row.map((cell, cellIndex) => {
  //         if (typeof cell === "object") {
  //           return cell.innerText;
  //         }
  //         return cell;
  //       })
  //     ),
  //     startY: 5,
  //     theme: "grid",
  //     margin: { top: 5, left: 5, right: 5 },
  //     styles: {
  //       fontSize: 9,
  //       cellPadding: 5,
  //       halign: "center",
  //       valign: "middle",
  //     },
  //     headStyles: {
  //       textColor: [0, 0, 0], // Black text for headers
  //       fontSize: 8,
  //       fillColor: null,
  //     },
  //     columnStyles,
  //     didParseCell: function (data) {
  //       const text = data.cell.raw?.innerText || "";

  //       const colorMap = {
  //         P: "#34C75A",
  //         LT: "#F18944",
  //         HD: "#78258F",
  //         A: "#EC0000",
  //         WO: "#FFCF0F",
  //         "L (PL)": "#3936D1",
  //         "L (LOP)": "#3936D1",
  //       };

  //       if (colorMap[text]) {
  //         data.cell.styles.textColor = colorMap[text];
  //       }

  //       // If the cell contains a numeric count in the summary columns, apply the respective color
  //       const columnIndex = data.column.index;
  //       const summaryColumnOffset = data.table.columns.length - 7; // Assuming last 7 columns are summary counts

  //       if (columnIndex >= summaryColumnOffset) {
  //         const countColors = [
  //           [52, 199, 90], // P (total_present)
  //           [241, 137, 68], // LT (total_late_days)
  //           [120, 37, 143], // HD (total_half_day)
  //           [236, 0, 0], // A (total_absent)
  //           [57, 54, 209], // L (PL) (total_on_pl)
  //           [57, 54, 209], // L (LOP) (total_lop)
  //           [255, 207, 15], // WO (total_weeklyoff)
  //         ];

  //         const colorIndex = columnIndex - summaryColumnOffset;
  //         if (colorIndex >= 0 && colorIndex < countColors.length) {
  //           data.cell.styles.textColor = countColors[colorIndex];
  //         }
  //       }
  //     },
  //     didDrawCell: function (data) {
  //       const { doc, cell } = data;

  //       // Draw cell border
  //       doc.setLineDash([1, 1], 0);
  //       doc.rect(cell.x, cell.y, cell.width, cell.height);

  //       // Handle the first column where images or text ("No Image Available") are placed
  //       if (isChecked && data.column.index === 0 && data.row.index !== 0) {
  //         const imgElement = table.rows[data.row.index]?.querySelector("img");

  //         if (imgElement) {
  //           const base64Image = imgElement.src;
  //           if (base64Image.startsWith("data:image")) {
  //             const imgWidth = 10; // Image width
  //             const imgHeight = 10; // Image height
  //             const x = cell.x + 5; // Adjust X position
  //             const y = cell.y + 5; // Adjust Y position
  //             doc.addImage(base64Image, "JPEG", x, y, imgWidth, imgHeight);
  //           }
  //         } else {
  //           // If no image, add "No Image Available" text centered
  //           doc.setFontSize(7);
  //           doc.text(
  //             "No Image",
  //             cell.x + cell.width / 2,
  //             cell.y + cell.height / 2,
  //             {
  //               align: "center",
  //             }
  //           );
  //         }
  //       }
  //     },
  //   });

  //   doc.save("attendance_report.pdf");
  // };

  // const handleExportPDF = () => {
  //   const isChecked = checked;
  //   const doc = new jsPDF("l", "mm", "a4"); // Landscape mode
  //   const table = document.getElementById("attendance-table");

  //   let tableData = [];
  //   let tableHeaders = [];

  //   const rows = table.querySelectorAll("tr");
  //   rows.forEach((row, rowIndex) => {
  //     let rowData = [];
  //     const cells = row.querySelectorAll("th, td");

  //     cells.forEach((cell, cellIndex) => {
  //       if (rowIndex === 0) {
  //         tableHeaders.push(cell.innerText);
  //       } else {
  //         rowData.push(cell);
  //       }
  //     });

  //     if (rowIndex > 0) {
  //       if (isChecked) {
  //         rowData.unshift(" ");
  //       }
  //       tableData.push(rowData);
  //     }
  //   });

  //   if (isChecked) {
  //     tableHeaders.unshift("Profile");
  //   }

  //   const columnStyles = isChecked
  //     ? {
  //         0: { cellWidth: 18 }, // Image column
  //         1: { cellWidth: 26 }, // Employee column
  //       }
  //     : {
  //         0: { cellWidth: 26 }, // Employee column
  //       };

  //   console.log("tableData length:", tableData.length); // Debug
  //   console.log("tableData:", tableData); // Debug

  //   doc.autoTable({
  //     head: [tableHeaders],
  //     body: tableData.map((row, rowIndex) =>
  //       row.map((cell, cellIndex) => {
  //         if (typeof cell === "object") {
  //           return cell.innerText;
  //         }
  //         return cell;
  //       })
  //     ),
  //     theme: "grid",
  //     margin: { top: 5, left: 5, right: 5 },
  //     styles: {
  //       fontSize: 6,
  //       cellPadding: 2, // Reduce padding to fit more content
  //       halign: "center",
  //       valign: "middle",
  //     },
  //     headStyles: {
  //       textColor: [0, 0, 0],
  //       fontSize: 8,
  //       fillColor: null,
  //     },
  //     columnStyles,
  //     didParseCell: function (data) {
  //       const text = (data.cell.raw?.innerText || "")
  //         .replace(/\s*\n\s*/g, " ")
  //         .trim();

  //       const colorMap = {
  //         P: "#34C75A",
  //         LT: "#F18944",
  //         HD: "#78258F",
  //         A: "#EC0000",
  //         WO: "#FFCF0F",
  //         "L (PL)": "#3936D1",
  //         "L (LOP)": "#3936D1",
  //         "-": "#808080",
  //       };

  //       const columnIndex = data.column.index;
  //       const summaryColumnOffset = data.table.columns.length - 7;

  //       if (columnIndex < summaryColumnOffset && colorMap[text]) {
  //         data.cell.styles.textColor = colorMap[text];
  //       }

  //       if (columnIndex >= summaryColumnOffset) {
  //         const countColors = [
  //           [52, 199, 90], // P
  //           [241, 137, 68], // LT
  //           [120, 37, 143], // HD
  //           [236, 0, 0], // A
  //           [57, 54, 209], // L (PL)
  //           [57, 54, 209], // L (LOP)
  //           [255, 207, 15], // WO
  //         ];

  //         const colorIndex = columnIndex - summaryColumnOffset;
  //         if (colorIndex >= 0 && colorIndex < countColors.length) {
  //           data.cell.styles.textColor = countColors[colorIndex];
  //         }
  //       }
  //     },
  //     didDrawCell: function (data) {
  //       const { doc, cell } = data;
  //       doc.setLineDash([1, 1], 0);
  //       doc.rect(cell.x, cell.y, cell.width, cell.height);

  //       if (isChecked && data.column.index === 0 && data.row.index !== 0) {
  //         const imgElement = table.rows[data.row.index]?.querySelector("img");
  //         if (imgElement) {
  //           const base64Image = imgElement.src;
  //           if (base64Image.startsWith("data:image")) {
  //             const imgWidth = 10;
  //             const imgHeight = 10;
  //             const x = cell.x + 5;
  //             const y = cell.y + 5;
  //             doc.addImage(base64Image, "JPEG", x, y, imgWidth, imgHeight);
  //           }
  //         } else {
  //           doc.setFontSize(7);
  //           doc.text(
  //             "No Image",
  //             cell.x + cell.width / 2,
  //             cell.y + cell.height / 2,
  //             { align: "center" }
  //           );
  //         }
  //       }
  //     },
  //   });

  //   doc.save("attendance_report.pdf");
  // };

  const handleExportPDF = (type) => {
    const id = selectedStoreValue?.map((data) => data?.value);
    const designationIds = designationId?.map((data) => data?.value);
    const activeInactives = activeInactive?.map((data) => data?.value);
    dispatch(
      getStoreDataMonthlyAll(
        id,
        selectedMonthYear,
        debouncedSearch,
        designationIds,
        activeInactives,
        checked,
        type
      )
    );
  };

  const handleExportCSV = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("attendance-table")
    ); // Use the table element directly
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance");

    // Write CSV
    XLSX.writeFile(wb, "attendance.csv");
  };

  const showmoreButtons = () => {
    setShowButtons(!showButtons);
  };

  return (
    <div className="content-wrapper">
      <div className="store_card">
        <div className="selector_for_table">
          <div className="month">
            <h5>Select Month & Year</h5>
            <Dropdown
              value={moment(
                `${months[selectedMonthYear.month]} ${selectedMonthYear.year}`,
                "MMMM YYYY"
              ).format("MMM-YY")}
              onChange={handleChange}
              data={filteredMonthYearOptions}
              clearSection={setSelectedMonthYear}
              hide={true}
            />
          </div>

          <div className="company">
            <h5>Select Company</h5>
            <Dropdown
              value={selectedCompanyValue}
              onChange={(selectedValue) => {
                handleCompanySelector(selectedValue);
              }}
              data={allcompanylists}
              clearSection={setSelectedCompanyValue}
              multiSelect={true}
            />
          </div>

          <div className="store">
            <h5>Select Store</h5>
            <Dropdown
              value={selectedStoreValue}
              onChange={(selectedValue) => {
                handleStoreSelector(selectedValue);
              }}
              data={allStorelists}
              clearSection={setSelectedStoreValue}
              multiSelect={true}
            />
          </div>

          <div className="employee">
            <h5>Search</h5>
            <Dropdown value={search} onChange={searchHandler} type="input" />
          </div>

          {/* <div className="designation">
            <h5>Designation</h5>
            <Dropdown
              value={designationId}
              onChange={(e) => {
                handleDesignationChange(e);
              }}
              data={designationlist}
              clearSection={setDesignationId}
              multiSelect={true}
            />
          </div> */}

          <div className="designation">
            <h5>Active/Inactive</h5>
            <Dropdown
              value={activeInactive}
              onChange={(e) => {
                handleActiveInactive(e);
              }}
              data={[
                { value: true, label: "Active" },
                { value: false, label: "Inactive" },
              ]}
              clearSection={setActiveInactive}
              multiSelect={true}
            />
          </div>

          <div className="checkbox">
            <div className="checkbox_text">
              <Checkbox checked={checked} onChange={profileShowHandler} />
              <p>With Profile</p>
            </div>
            <div style={{ position: "relative" }}>
              <button onClick={showmoreButtons}>Export</button>
              {showButtons && (
                <div style={{ position: "absolute" }} className="exportbtnss">
                  <ul>
                    <li onClick={() => handleExportPDF("csv")}>csv</li>
                    <li onClick={() => handleExportPDF("xlsx")}>xlsx</li>
                    <li onClick={() => handleExportPDF("pdf")}>pdf</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="table_attendance">
          <table id="attendance-table">
            <thead>
              <tr>
                <th
                  style={{
                    borderLeft: "none",
                    fontSize: "12px",
                    fontWeight: "500",
                    lineHeight: "18px",
                    textAlign: "center",
                    color: "#000000",
                  }}
                >
                  Employee
                </th>
                {days.map((day, index) => (
                  <th
                    key={index}
                    style={{
                      color: "#252C58",
                      fontSize: "10px",
                      fontWeight: "500",
                      lineHeight: "15px",
                      textAlign: "center",
                    }}
                  >
                    {day.day} <br /> {day.dayOfWeek}
                  </th>
                ))}
                <th
                  style={{
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  P
                </th>
                <th
                  style={{
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  L
                </th>
                <th
                  style={{
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  HD
                </th>
                <th
                  style={{
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  A
                </th>
                <th
                  style={{
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  PL
                </th>
                <th
                  style={{
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  LOP
                </th>
                <th
                  style={{
                    borderRight: "none",
                    color: "#252C58",
                    fontSize: "10px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    textAlign: "center",
                  }}
                >
                  WO
                </th>
              </tr>
            </thead>
            <tbody>
              {employees?.map((employee) => (
                <tr key={employee.id}>
                  <td
                    style={{
                      borderLeft: "none",
                      fontSize: "12px",
                      fontWeight: "500",
                      lineHeight: "22px",
                      textAlign: "left",
                    }}
                  >
                    <div className="d-flex justify-content-start gap-2">
                      {checked && (
                        <div>
                          {employee.employee_profileImage ? (
                            <img
                              src={employee.employee_profileImageBase64}
                              alt=""
                              style={{
                                width: "40px",
                                height: "auto",
                              }}
                            />
                          ) : (
                            <span
                              className="icon"
                              style={{
                                display: employee.employee_profileImage
                                  ? "none"
                                  : "block",
                                fontSize: "8px",
                                color: "#7182B6",
                                background: "#ffffff",
                                height: "40px",
                                width: "40px",
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            ></span>
                          )}
                        </div>
                      )}
                      <div>
                        <span style={{ color: "#2C357D" }}>
                          {employee.employee_name}{" "}
                          {`[${employee?.employee_emp_id}]`}
                        </span>{" "}
                        <br />
                        <span style={{ color: "#7182B6" }}>
                          {employee.employee_designation}
                        </span>
                      </div>
                    </div>
                  </td>
                  {days.map(({ fullDate }, index) => {
                    const attendanceEntry = employee?.attendance_by_day.find(
                      (item) => item.day === fullDate
                    );

                    const status = attendanceEntry?.attendance?.[0]?.status;
                    const type = attendanceEntry?.attendance?.[0]?.leaveType;

                    const statusMap = {
                      Present: { text: "P", color: "#34C75A" },
                      "Late-Arrival": { text: "L", color: "#F18944" },
                      Absent: { text: "A", color: "#EC0000" },
                      "Half-Day": { text: "HD", color: "#78258F" },
                      "Weekly-OFF": { text: "WO", color: "#FFCF0F" },
                    };

                    const statusMap2 = {
                      LOP: { text: "LOP", color: "#3936D1" },
                      PL: { text: "PL", color: "#3936D1" },
                      "Weekly Off": { text: "WO", color: "#FFCF0F" },
                    };

                    const statusObj = statusMap[status];
                    const typeObj = statusMap2[type];

                    return (
                      <td
                        key={index}
                        style={{
                          color: statusObj?.color || typeObj?.color || "gray",
                        }}
                      >
                        {statusObj?.text ||
                          (type && typeObj?.text !== "WO" ? (
                            <>
                              L
                              <br />({typeObj?.text})
                            </>
                          ) : (
                            typeObj?.text || "-"
                          ))}
                      </td>
                    );
                  })}

                  <td style={{ color: "#34C75A" }}>
                    {employee?.total_present}
                  </td>
                  <td style={{ color: "#F18944" }}>
                    {employee?.total_late_days}
                  </td>
                  <td style={{ color: "#78258F" }}>
                    {employee?.total_half_day}
                  </td>
                  <td style={{ color: "#EC0000" }}>{employee?.total_absent}</td>
                  <td style={{ color: "#3936D1" }}>{employee?.total_on_pl}</td>
                  <td style={{ color: "#3936D1" }}> {employee?.total_lop}</td>
                  <td style={{ borderRight: "none", color: "#FFCF0F" }}>
                    {employee?.total_weeklyoff}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        listData={monthlyStoreData?.meta}
        setPageData={setCurrentPage}
      />
    </div>
  );
};

export default AttendanceConsolidated;
